import { render, staticRenderFns } from "./TestCenter.vue?vue&type=template&id=51f18775&scoped=true&"
import script from "./TestCenter.vue?vue&type=script&lang=js&"
export * from "./TestCenter.vue?vue&type=script&lang=js&"
import style0 from "./TestCenter.vue?vue&type=style&index=0&id=51f18775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f18775",
  null
  
)

export default component.exports